//import My_Did_Widget_Client from '../nodemodules/@patronymus/my_card_widget_react_client';
import My_Did_Widget_Client from '@patronymus/my_card_widget_react_client';

class PrimusMoneyDidWidgetService {

	constructor(widget_client_id) {
		this.widget_client_id = widget_client_id;
		this.uuid = PrimusMoneyDidWidgetService.guid();

		this.widget = null;
	}

	getWidgetClient() {
		let my_did_widget_client = My_Did_Widget_Client.getObject();

		return my_did_widget_client.getWidgetObject(this.widget_client_id);
	}

	// static functions
	static guid() {
		let my_did_widget_client = My_Did_Widget_Client.getObject();

		return my_did_widget_client.guid();
	}

	static getObject(widget_client_id) {
		return new PrimusMoneyDidWidgetService(widget_client_id);
	}


};

export default PrimusMoneyDidWidgetService;